import Transformer from './transformer'
import moment from 'moment'
import { assetURL, objectToForm } from '@/utils'

export default class InvoiceReceiptTransformer extends Transformer {
  static fetch(invoiceReceipt) {
    return {
      id : invoiceReceipt.id,
      taxReceipt : invoiceReceipt.tax_receipt,
      uuids : invoiceReceipt.tax_receipt,
      customer : invoiceReceipt.customer.customer_name,
      customerName: invoiceReceipt.customer.customer_name,
      description: invoiceReceipt.description,
      isDelivered: invoiceReceipt.is_delivered,
      isAuthorized: invoiceReceipt.is_validated,
      deliveredDate: invoiceReceipt.delivered_date,
      file: assetURL(invoiceReceipt.file_invoiceReceipt),
      stampedFile: assetURL(invoiceReceipt.stamped_file),
      stampedDate: invoiceReceipt.stamped_date,
      invoicedDates: {
        addDate : invoiceReceipt.add_date,
      },
      addDate: moment(invoiceReceipt.add_date),
    }
  }

  static send(invoiceReceipt) {
    const { stampedFile, stampedDate } = invoiceReceipt

    return objectToForm({
      id : invoiceReceipt.id,
      stamped_file: stampedFile,
      stamped_date: moment(stampedDate).format('YYYY-MM-DD'),
    })
  }
}


// WEBPACK FOOTER //
// ./src/transformers/invoiceReceipt.js